import type { Component, ComponentProps } from "solid-js";
import { splitProps } from "solid-js";

import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

import { cn } from "~/util/utils";

const badgeVariants = cva(
	"inline-flex items-center px-4 py-1 uppercase text-xs font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				filled: "bg-accent text-white border-accent",
				default: "border bg-white",
				outline: "border border-accent text-accent",
				transparent: "text-accent",
				light: "bg-accent/10 text-accent",
			},
			radius: {
				default: "rounded-xl",
				sm: "rounded-sm",
				md: "rounded-md",
				lg: "rounded-lg",
				xl: "rounded-xl",
			},
		},
		defaultVariants: {
			variant: "default",
			radius: "default",
		},
	},
);

type BadgeProps = ComponentProps<"div"> & VariantProps<typeof badgeVariants>;

const Badge: Component<BadgeProps> = (props) => {
	const [local, others] = splitProps(props, ["class", "variant", "radius"]);
	return (
		<div
			class={cn(badgeVariants({ variant: local.variant, radius: local.radius }), local.class)}
			{...others}
		/>
	);
};

export type { BadgeProps };
export { Badge, badgeVariants };
